"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var location_details_html_1 = __importDefault(require("./location-details.html"));
var pickup_location_modal_controller_1 = __importDefault(require("./pickup-location-modal.controller"));
var add_student_modal_html_1 = __importDefault(require("../add-student-modal/add-student-modal.html"));
var add_student_modal_controller_1 = __importDefault(require("../add-student-modal/add-student-modal.controller"));
var cancel_drive_modal_controller_1 = __importDefault(require("../cancel-drive-modal/cancel-drive-modal.controller"));
var cancel_drive_modal_html_1 = __importDefault(require("../cancel-drive-modal/cancel-drive-modal.html"));
var new_custom_pickup_location_modal_html_1 = __importDefault(require("./new-custom-pickup-location-modal.html"));
var new_custom_pickup_location_modal_controller_1 = __importDefault(require("./new-custom-pickup-location-modal.controller"));
var AdminDrivesEditController = /** @class */ (function () {
    function AdminDrivesEditController($rootScope, $state, $uibModal, UsersModel, DrivesModel, FlashService, driveSession, AdminEditDriveSessionService, AdhocLocations, policyData, campuses, sessionTypes, vehicles, instructors) {
        var _this = this;
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.loading = true;
        this.policyData = {
            'AllowGradeDuringDrive': policyData.AllowGradeDuringDrive,
            'AdhocPickupLocationPolicyData': policyData.AdhocPickupLocationPolicyData,
            'UseReportCards': policyData.UseReportCards,
            'UseServiceArea': policyData.UseServiceArea,
            'StudentsCanBook': policyData.StudentsCanBook,
        };
        this.adhocPickupLocations = AdhocLocations;
        this.service = AdminEditDriveSessionService;
        this.service.setDriveSession(structuredClone(driveSession));
        this.initialLoad = true;
        this.initialDriveSession = structuredClone(driveSession);
        // reference to make two way binding stuff work
        this.driveSession = this.service.state.driveSession;
        // set "saved" property on students so we can remove them or cancel them properly
        if (this.driveSession.observation === false) {
            if (this.driveSession.student) {
                this.driveSession.student.saved = true;
            }
        }
        else {
            if (this.driveSession.students) {
                this.driveSession.students.map(function (student) {
                    student.saved = true;
                    return student;
                });
            }
        }
        this.form = this.service.state.form;
        this.rules = this.service.state.rules;
        this.toggleStudentSchoolOverride = false;
        this.$uibModal = $uibModal;
        this.UsersModel = UsersModel;
        this.DrivesModel = DrivesModel;
        this.FlashService = FlashService;
        this.gradingLessonEnabled = this.gradingLessonEnabled.bind(this);
        ////////
        // set instructor
        this.instructors = instructors;
        this.instructors.forEach(function (instructor) {
            if (_this.driveSession.instructor && _this.driveSession.instructor.id === instructor.id) {
                _this.driveSession.instructor = instructor;
            }
        });
        if (!this.driveSession.instructor) {
            this.driveSession.instructor = this.instructors[0];
        }
        // set vehicles
        this.form.vehicles = vehicles;
        this.form.vehicles.forEach(function (vehicle) {
            if (_this.driveSession.vehicle && _this.driveSession.vehicle.id === vehicle.id) {
                _this.driveSession.vehicle = vehicle;
            }
        });
        if (!this.driveSession.vehicle) {
            this.driveSession.vehicle = this.form.vehicles[0];
        }
        // set whether or not drive session allows custom pick up locations
        this.rules.sectorsRequired = this.policyData.UseServiceArea.FeatureEnabled && (driveSession.type.allow_custom_pickup_locations === true || driveSession.type.allow_custom_dropoff_locations === true);
        // set drive session location for the ng-options attribute
        this.form.campuses = campuses;
        if (driveSession.location) {
            var addSessionLocationToSchoolLocations_1 = true;
            this.form.campuses.forEach(function (location) {
                if (location.name === driveSession.location.name) {
                    addSessionLocationToSchoolLocations_1 = false;
                }
            });
            if (addSessionLocationToSchoolLocations_1 === true) {
                this.form.campuses.push(driveSession.location);
            }
        }
        if (this.policyData.UseServiceArea.FeatureEnabled) {
            if (!this.driveSession.location) {
                this.driveSession.location = Object.assign({}, this.form.campuses[0]);
            }
            this.form.campuses.forEach(function (location) {
                if (location.id === _this.driveSession.location.id) {
                    _this.driveSession.location = location;
                }
            });
        }
        if (this.driveSession.student_id) {
            this.adhocPickupLocations.forEach(function (adhoc_location) {
                _this.driveSession.student.pickuplocations.push(adhoc_location);
            });
        }
        // set initial drive session type
        this.form.sessiontypes = sessionTypes.filter(function (type) {
            if (_this.driveSession.type.id === type.id) {
                return type;
            }
            return type.status === 'Active';
        });
        this.form.sessiontypes.forEach(function (type) {
            if (type.id === driveSession.type.id) {
                _this.driveSession.type = type;
            }
        });
        if (this.policyData.UseServiceArea.FeatureEnabled) {
            this.form.sectors = [].concat.apply([], this.driveSession.location.zoneparts);
            this.form.zones = [].concat.apply([], this.driveSession.location.zones);
            // set the initially selected sectors
            this.form.sectors.forEach(function (locationSector, index) {
                driveSession.zoneparts.forEach(function (driveSector) {
                    if (locationSector.id === driveSector.id) {
                        _this.form.sectors[index].selected = true;
                    }
                });
            });
            // set the initially selected zone
            this.form.zones.forEach(function (zone, index) {
                driveSession.zoneparts.forEach(function (sector) {
                    if (sector.zone_id === zone.id) {
                        _this.form.zones[index].selected = true;
                    }
                });
            });
            this.service.updateSelectAllZonesLabel();
        }
        this.init().then(function (loading) {
            // setup complete
        }).catch(function (Error) {
            console.error(Error);
        });
    }
    //////////////////////////////////////////////
    AdminDrivesEditController.prototype.init = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                try {
                    this.cancelationRules = {};
                    this.rulesLoadedForStudent = false;
                    if (this.driveSession.student_id) {
                        this.UsersModel.getStudentCancellationRules(this.driveSession.id).then(function (response) {
                            _this.rulesLoadedForStudent = true;
                            _this.cancelationRules = response.data;
                        });
                    }
                    else {
                        this.rulesLoadedForStudent = true;
                    }
                    this.$rootScope.$on('MESSAGE_CLEARED', function () {
                        _this.form.submitted = false;
                    });
                    this.loading = false;
                    return [2 /*return*/, this.loading];
                }
                catch (Error) {
                    console.log(Error);
                    throw Error;
                }
                return [2 /*return*/];
            });
        });
    };
    AdminDrivesEditController.prototype.gradingLessonEnabled = function () {
        var durationInMinutes = (parseInt(this.driveSession.sessionLengthHours) * 60) + parseInt(this.driveSession.sessionLengthMinutes);
        var datestring = (0, moment_1.default)(this.driveSession.drive_date).format('YYYY-MM-DD') + ' ' + (0, moment_1.default)(this.driveSession.start_time).format('HH:mm:ss');
        var endTime = (0, moment_1.default)(datestring).add(durationInMinutes, 'minutes').toDate();
        if (this.policyData.AllowGradeDuringDrive.FeatureEnabled === false) {
            // is now after end time
            return endTime < new Date();
        }
        // is now after start time
        return (0, moment_1.default)(this.driveSession.drive_date + ' ' + this.driveSession.start_time).toDate() < new Date();
    };
    AdminDrivesEditController.prototype.handleObservationFieldUpdate = function () {
        var _this = this;
        if (this.driveSession.observation === false) {
            if (this.driveSession.students.length > 0) {
                if (this.driveSession.students.length === 1) {
                    this.driveSession.student = this.driveSession.students[0];
                    this.driveSession.student_id = this.driveSession.students[0].id;
                }
                else {
                    // prompt to cancel for all students in the observation
                    this.driveSession.students.forEach(function (student, index) {
                        _this.cancelSessionModal(student.id, index);
                    });
                }
            }
            delete this.driveSession.students;
            if (this.driveSession.student) {
                this.driveSession.status = 'Taken';
            }
            else {
                this.driveSession.status = 'Available';
            }
        }
        // this should check the student_id, if observation is true add student_id to .students()
        if (this.driveSession.observation === true) {
            if (this.driveSession.student) {
                if (!this.driveSession.students) {
                    this.driveSession.students = [];
                }
                this.driveSession.students = [].concat(__spreadArray(__spreadArray([], this.driveSession.students, true), [this.driveSession.student], false));
                delete this.driveSession.student;
                this.driveSession.student_id = null;
                if (this.driveSession.vehicle.seats < this.driveSession.students.length) {
                    this.driveSession.status = 'Available';
                }
                else {
                    this.driveSession.status = 'Taken';
                }
            }
        }
    };
    AdminDrivesEditController.prototype.selectAllSectors = function () {
        var _this = this;
        this.form.sectors.forEach(function (sector, index) {
            _this.form.sectors[index].selected = true;
        });
        this.form.zones.forEach(function (zone, index) {
            _this.form.zones[index].selected = true;
        });
    };
    AdminDrivesEditController.prototype.updateSessionTypeDefault = function () {
        if (this.driveSession.type.hidden === true) {
            this.driveSession.private = 'Y';
        }
        else {
            this.driveSession.private = 'N';
        }
        this.rules.sectorsRequired = this.driveSession.type.allow_custom_pickup_locations === true || this.driveSession.type.allow_custom_dropoff_locations === true;
    };
    /**
     * Add student modal
     */
    AdminDrivesEditController.prototype.addStudentModal = function () {
        var _this = this;
        var modalInstance = this.$uibModal.open({
            animation: true,
            template: add_student_modal_html_1.default,
            controller: add_student_modal_controller_1.default,
            controllerAs: 'vm',
            size: 'lg',
            resolve: {
                'drivesession': function () { return _this.driveSession; },
                'toggleStudentSchoolOverride': function () { return _this.toggleStudentSchoolOverride; }
            }
        });
        modalInstance.result.then(function (data) {
            _this.driveSession = data.drivesession;
            if (_this.driveSession.observation === false) {
                _this.adhocPickupLocations.forEach(function (adhoc_location) {
                    data.drivesession.student.pickuplocations.push(adhoc_location);
                });
                _this.driveSession.student_id = data.drivesession.student.id;
                _this.driveSession.status = 'Taken';
            }
            else {
                _this.driveSession.student_id = null;
                _this.driveSession.students = data.drivesession.students;
                if (_this.driveSession.students.length === _this.driveSession.vehicle.seats) {
                    _this.driveSession.status = 'Taken';
                }
                else {
                    _this.driveSession.status = 'Available';
                }
            }
            if (_this.driveSession.type.allow_custom_pickup_locations === false && !_this.driveSession.pickuplocation) {
                _this.driveSession.pickuplocation = _this.driveSession.location;
            }
            if (_this.driveSession.type.allow_custom_dropoff_locations === false && !_this.driveSession.dropofflocation) {
                _this.driveSession.dropofflocation = _this.driveSession.location;
            }
            _this.toggleStudentSchoolOverride = data.toggleStudentSchoolOverride;
        }, function () {
            //$log.info('Modal dismissed at: ' + new Date());
        });
    };
    /**
     * Cancel Session modal
     */
    AdminDrivesEditController.prototype.cancelSessionModal = function (student_id, index) {
        var _this = this;
        if (index === void 0) { index = null; }
        var modalInstance = this.$uibModal.open({
            animation: true,
            template: cancel_drive_modal_html_1.default,
            controller: cancel_drive_modal_controller_1.default,
            controllerAs: 'vm',
            size: 'lg',
            resolve: {
                'drivesession': function () { return _this.driveSession; },
                'student_id': function () { return student_id; },
                'rules': function () { return _this.cancelationRules; }
            }
        });
        modalInstance.result.then(function (selectedItem) {
            // $scope.selected = selectedItem;
            if (index !== null) {
                _this.removePassenger(index);
                if (_this.service.hasStudents() === false) {
                    _this.driveSession.status = 'Available';
                }
            }
            else {
                delete _this.driveSession.student;
                _this.driveSession.student_id = null;
                if (_this.service.hasStudents() === false) {
                    _this.driveSession.status = 'Available';
                }
            }
        }, function () { });
    };
    AdminDrivesEditController.prototype.addNewCustomPickupLocation = function (type) {
        var _this = this;
        if (type === void 0) { type = 'Pick-up Location'; }
        var modalInstance = this.$uibModal.open({
            animation: true,
            template: new_custom_pickup_location_modal_html_1.default,
            controller: new_custom_pickup_location_modal_controller_1.default,
            controllerAs: 'vm',
            size: 'md',
            resolve: {
                data: function () {
                    return {
                        locationType: type
                    };
                }
            }
        });
        modalInstance.result.then(function (selectedItem) {
            _this.driveSession.student.pickuplocations.push(selectedItem);
            if (type === 'Pick-up Location') {
                _this.driveSession.pickuplocation = _this.driveSession.student.pickuplocations[_this.driveSession.student.pickuplocations.length - 1];
            }
            else {
                _this.driveSession.dropofflocation = _this.driveSession.student.pickuplocations[_this.driveSession.student.pickuplocations.length - 1];
            }
        }, function () {
        });
    };
    AdminDrivesEditController.prototype.previewPickupLocation = function (title, location) {
        var modalInstance = this.$uibModal.open({
            animation: true,
            template: location_details_html_1.default,
            controller: pickup_location_modal_controller_1.default,
            controllerAs: 'vm',
            size: 'sm',
            resolve: {
                'data': {
                    'title': title,
                    'pickuplocation': location
                }
            }
        });
        modalInstance.result.then(function (selectedItem) {
        }, function () {
        });
    };
    AdminDrivesEditController.prototype.clearForm = function () {
        this.service.resetDriveSession();
        //this.service.resetForm();
        //this.checkSelect();
        // TODO: Avoid manipulating the rules object directly
        this.rules.hasSectors = false;
    };
    AdminDrivesEditController.prototype.checkSelect = function () {
        return this.service.checkSelectedSectors();
    };
    AdminDrivesEditController.prototype.zoneSelected = function (zone) {
        var _this = this;
        this.service.updateSelectAllZonesLabel();
        if (zone.selected === true) {
            // add all sectors of zone
            this.form.sectors.forEach(function (sector, index) {
                if (sector.zone_id === zone.id) {
                    _this.form.sectors[index].selected = true;
                }
            });
        }
        else {
            // remove all sectors of zone
            this.form.sectors.forEach(function (sector, index) {
                if (sector.zone_id === zone.id) {
                    _this.form.sectors[index].selected = false;
                }
            });
        }
    };
    AdminDrivesEditController.prototype.sectorSelected = function (sector) {
        var _this = this;
        if (sector.selected === true) {
            // add the sector's zone
            this.form.zones.forEach(function (zone, index) {
                if (sector.zone_id === zone.id) {
                    _this.form.zones[index].selected = true;
                }
            });
        }
        else {
            // remove the sector's zone
            this.form.zones.forEach(function (zone, index) {
                // are there no selected sectors in this zone?
                var remainingSelectedSectors = _this.form.sectors.filter(function ($sector) {
                    return $sector.zone_id === zone.id && $sector.selected === true;
                });
                // if not deselect the zone
                if (remainingSelectedSectors.length > 0 === false) {
                    _this.form.zones[index].selected = false;
                }
            });
        }
        this.service.updateSelectAllZonesLabel();
        // this.checkSelect();
    };
    AdminDrivesEditController.prototype.resetSessionForm = function () {
        this.form.zones = [].concat.apply([], this.driveSession.location.zones);
        this.driveSession.zones = [];
        this.form.sectors = [].concat.apply([], this.driveSession.location.zoneparts);
        if (this.rules.sectorsRequired === false) {
            this.selectAllSectors();
        }
    };
    /**
     * Delete the drive session
     */
    AdminDrivesEditController.prototype.deleteDrive = function () {
        var _this = this;
        if (confirm("Are you sure you want to delete this session?") === false) {
            return;
        }
        this.DrivesModel.deleteDrive(this.driveSession.id).then(function (response) {
            _this.FlashService.setMessage({
                'type': 'success',
                'message': response.message
            });
            _this.$state.go('drivecoach.admin.calendar', {}, { 'reload': true });
        });
    };
    AdminDrivesEditController.prototype.removePassenger = function (index) {
        if (this.driveSession.observation === false) {
            delete this.driveSession.student;
            this.driveSession.student_id = null;
            this.driveSession.status = 'Available';
        }
        else {
            this.driveSession.students.splice(index, 1);
            if (this.driveSession.vehicle.seats != this.driveSession.students.length) {
                this.driveSession.status = 'Available';
            }
        }
    };
    AdminDrivesEditController.prototype.cleanGeom = function (sector) {
        delete sector.geom;
        return sector;
    };
    AdminDrivesEditController.prototype.goToReportCard = function (studentId) {
        if (this.driveSession.type.reportcardtype.name === 'Graded') {
            this.$state.go("drivecoach.admin.createreportcard", {
                driveId: this.driveSession.id,
                studentId: studentId,
            });
        }
        if (this.driveSession.type.reportcardtype.name === 'Pass/Fail') {
            this.$state.go("drivecoach.admin.createpassfailreportcard", {
                driveId: this.driveSession.id,
                studentId: studentId
            });
        }
        if (this.driveSession.type.reportcardtype.name === 'Standard') {
            this.$state.go("drivecoach.admin.gradegenericreportcard", {
                driveId: this.driveSession.id,
                studentId: studentId,
            });
        }
    };
    /**
     * Update the drive session
     *
     * @param isValid
     * @returns {boolean}
     */
    AdminDrivesEditController.prototype.updateSession = function (isValid) {
        var _this = this;
        this.form.submitted = true;
        if (isValid) {
            var Session = structuredClone(this.driveSession);
            if (Session.location) {
                Session.overrideLocation = Session.student_id !== null && Session.location.school_id !== Session.student.school_id;
            }
            else {
                Session.overrideLocation = false;
            }
            Session.session_length = (parseInt(this.driveSession.sessionLengthHours) * 60) + parseInt(this.driveSession.sessionLengthMinutes);
            Session.formatTime = (0, moment_1.default)(this.driveSession.start_time).format("HH:mm:ss");
            Session.formatDate = (0, moment_1.default)(this.driveSession.drive_date).format("YYYY-MM-DD");
            Session.toggleStudentSchoolOverride = this.toggleStudentSchoolOverride;
            Session.sectors = [].concat(this.form.sectors).filter(function (sector) { return sector.selected === true; }).map(this.cleanGeom);
            delete Session.sessionLengthHours;
            delete Session.sessionLengthMinutes;
            delete Session.showCancel;
            delete Session.plots;
            if (Session.instructor.id === 0) {
                delete Session.instructor;
            }
            if (Session.vehicle.id === 0) {
                delete Session.vehicle;
            }
            // lighten the payload a bit
            if (Session.hasOwnProperty('student') && Session.student) {
                if (Session.student.hasOwnProperty('pickuplocations') && Session.student.pickuplocations) {
                    Session.student.pickuplocations = Session.student.pickuplocations.map(function (location) {
                        if (location.hasOwnProperty('zoneparts')) {
                            // TODO: Remove this when I have a map endpoint
                            location.zoneparts = location.zoneparts.map(_this.cleanGeom);
                        }
                        return location;
                    });
                }
            }
            if (Session.hasOwnProperty('location') && Session.location) {
                if (Session.location.hasOwnProperty('zones') && Session.location.zones) {
                    Session.location.zones = Session.location.zones.map(function (zone) {
                        if (zone.hasOwnProperty('zoneparts')) {
                            // TODO: Remove this when I have a map endpoint
                            zone.zoneparts = zone.zoneparts.map(_this.cleanGeom);
                        }
                        return zone;
                    });
                }
            }
            if (this.policyData.UseServiceArea.FeatureEnabled === false) {
                delete Session.location;
                delete Session.zones;
                delete Session.zoneparts;
            }
            this.DrivesModel.updateDrive(Session).then(function (response) {
                _this.FlashService.setMessage({ 'type': 'success', 'message': response.message });
                _this.form.submitted = false;
                _this.$state.go('drivecoach.admin.calendar', {}, { 'reload': true });
            }).catch(function (error) {
                _this.form.submitted = false;
            });
        }
        else {
            this.form.submitted = false;
            this.FlashService.setMessage({ 'type': 'error', 'message': 'Please fill the form.' });
        }
    };
    return AdminDrivesEditController;
}());
AdminDrivesEditController.$inject = ['$rootScope', '$state', '$uibModal', 'UsersModel', 'DrivesModel', 'FlashService', 'driveSession', 'AdminEditDriveSessionService', 'AdhocLocations', 'policyData', 'campuses', 'sessionTypes', 'vehicles', 'instructors'];
exports.default = AdminDrivesEditController;
